module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-9.c355192f.png";